<template>
  <div>
  <div class="d-flex align-items-center justify-content-between pdt-4 pdb-3">
    <div class="d-flex flex-grow-1 ">
      <input
          id="commentFileUpload"
          ref="input"
          :accept="allowExt()"
          class="d-none"
          name="image"
          type="file"
          @change="uploadFile"
      />
      <button :class="isIconActive ? 't-color-iconActive' : 't-color-textfieldGuid'"
              class="material-icons mdc-icon-button mgl--12 font-26"
              tabindex="0" @click="openFileUpload('commentFileUpload')" @keypress="openFileUpload('commentFileUpload')">collections
      </button>
      <slot name="attachFile"></slot>
    </div>
    <slot name="submitButton"></slot>
    <slot name="showInfo"></slot>
  </div>
  </div>
</template>

<script>
import {mediaTypeConstants} from "@/utils/enum/MediaTypeConstants";

export default {
  name: "PhotoAlbum",

  props: ['form'],

  data() {
    return {
      mediaTypeConstants: mediaTypeConstants
    }
  },

  computed: {
    isIconActive() {
      if (this.form.images) {
        return this.form.images && this.form.images.length > 0
      } else {
        return _.some(this.form.contents.files, (file) => {
          return file.saveType.value === mediaTypeConstants.MEDIA_SAVE_TYPE.value
        })
      }
    }
  },

  methods: {
    allowExt() {
      return "image/jpeg, image/jpg, image/png, image/gif, video/mp4, video/mp4v, video/mpg4, video/m4v, video/quicktime, video/avi, video/wmv, video/mkv, video/mk3d, video/mks, video/webm";
    },

    uploadFile(evt) {
      this.$emit('uploadFile', evt);
    },

    toggleDocument() {
      this.$emit('toggleDocument');
    },

    removeImage() {
      this.$emit('removeImage');
    },

    getType(contentType) {
      if (contentType) {
        return contentType.split("/")[0];
      }
    },

    /**
     * 아이디 선택자 클릭 메소드
     * @param {String} status 선택자 아이디 엘레먼트
     */
    openFileUpload(status) {
      document.getElementById(status).click();
    },
  }
}
</script>

<style scoped>

</style>
